module.exports = __webpack_public_path__ + "static/media/loader-spinner.b659970b.svg";